export var win = typeof window !== 'undefined' ? window : {};
export var doc = typeof document !== 'undefined' ? document : {
  documentElement: {}
};
export var docEl = doc && doc.documentElement || doc && doc.body;
export var winScreen = win && win.screen;